import useAuth from './useAuth';

const useCompany = () => {
  const { company, userCompany } = useAuth();

  return {
    company,
    userCompany
  };
};

export default useCompany;
